enum TokenTypesEnum {
    SUPPLIER_USER = 1,
    VENDOR_USER = 2,
    SUPPLIER_VENDOR = 3,
    VENDOR_VENDOR = 4,
    SUPPLIER_VENDOR_SOURCE = 5,
}

export default TokenTypesEnum;
